<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-plug`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M13 4a1 1 0 011 1v4h20V5a1 1 0 011-1h2a1 1 0 011 1v4h5a1 1 0 011 1v2a1 1 0 01-1 1h-1v3c0 9.265-7 16.895-16 17.89V39a3 3 0 106 0 7 7 0 017-7h4a1 1 0 011 1v2a1 1 0 01-1 1h-4a3 3 0 00-3 3 7 7 0 11-14 0v-5.11C13 32.896 6 25.265 6 16v-3H5a1 1 0 01-1-1v-2a1 1 0 011-1h5V5a1 1 0 011-1h2zm25 9H10v3c0 7.732 6.268 14 14 14s14-6.268 14-14v-3z"/></svg>
</template>
<script>

export default {
  name: 'IconPlug',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
